<template>
  <div class="balance-content">
    <div class="top">
      <span>{{ `${TLang("使用抵扣1", "orderConfirm")}${integralName}${TLang("使用抵扣2", "orderConfirm")}` }}</span>
      <i
        class="el-input__icon el-icon-arrow-up rotate-180"
        :class="showStatus ? 'is-reverse' : ''"
        @click="changeShow()"
      ></i>
      <span v-show="deductionMoney" class="tip"
        >{{ TLang("抵扣", "card")
        }}<span class="red">{{ deductionMoney }}</span
        >{{ integralUnitName }}</span
      >
    </div>
    <div v-show="showStatus" class="bottom">
      <div class="use-select">
        <span
          :class="{ 'use-tab': true, active: type === '0' }"
          @click="type = '0'"
          >{{ `${ TLang("可用", "orderConfirm")}(${usableIntegralInfoList.length})` }}</span
        >
        <span
          :class="{ 'use-tab': true, 'un-use-tab': true, active: type === '1' }"
          @click="type = '1'"
          >{{ `${ TLang("不可用", "orderConfirm")}(${unavailableIntegralList.length})` }}</span
        >
      </div>
      <div v-if="type === '0'">
        <ul v-if="usableIntegralInfoList.length">
          <li
            v-for="(item, index) in usableIntegralInfoList"
            :key="index"
            class="balance-item use-bg"
            :class="item.checked === 'Y' ? 'sel-border' : 'noSel-border'"
            @click="changeStatus(index, item)"
          >
            <img
              v-show="item.checked === 'Y'"
              :src="require('@assets/images/group_sel.png')"
              class="sel-image"
            />
            <p class="jifen">
              {{ item.pointName }}
            </p>
            <p class="name use-color">
              {{ `${TLang("可用余额", "orderConfirm")}${item.pointUnitName?`(${item.pointUnitName || ""})`:''}` }}
            </p>
            <p class="interBalance">
              {{ formatBalance(item.showBalance)[0]
              }}<em>.{{ formatBalance(item.showBalance)[1] }}</em>
            </p>
            <p v-if="item.expiredTime" class="due">
              {{ `${TLang("有效期至", "card")}:${item.expiredTime || ''}` }}
            </p>
            <p v-show="integralInfo && integralInfo.isThirdAccountInventory === 1" class="reason-tip">
              <img
                :src="require('@/assets/images/icon_deliver_tip.png')"
              />{{ integralInfo.thirdAccountInventoryPrompt || '暂不可用' }}
            </p>
          </li>
        </ul>
        <div v-else class="empty-data">{{ TLang("暂无可用积分", "card") }}</div>
      </div>
      <div v-if="type === '1'">
        <ul v-if="unavailableIntegralList.length">
          <li
            v-for="(item, index) in unavailableIntegralList"
            :key="index"
            class="balance-item nouse-bg noSel-border"
          >
            <p class="jifen">
              {{ item.pointName }}
            </p>
            <p class="name nouse-color">
              {{ `${TLang("可用余额", "card")}${item.pointUnitName?`(${item.pointUnitName || ""})`:''}` }}
            </p>
            <p class="interBalance">
              {{ formatBalance(item.showBalance)[0]
              }}<em>.{{ formatBalance(item.showBalance)[1] }}</em>
            </p>
            <p v-if="item.expiredTime" class="due gray-color">
              {{ `${TLang("有效期至", "card")}:${item.expiredTime}` }}
            </p>
            <p class="reason-tip">
              <img
                :src="require('@/assets/images/icon_deliver_tip.png')"
              />{{ TLang("暂不可用", "orderConfirm") }}
            </p>
          </li>
        </ul>
        <div v-else class="empty-data">{{ TLang("暂无不可用积分", "orderConfirm") }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Toast from "@components/simpleToast";
import { payTotastNames } from "@utils/config";
export default {
  name: "IntegralList",
  props: {
    interestsInfo:Object,
    sendGio:Function,
  },

  data() {
    return {
      showStatus: true,
      integralInfo: JSON.parse(JSON.stringify(this.interestsInfo)),
      type: "0",
    };
  },
  computed: {
    // 单位名称
    integralUnitName() {
      return (
        (this.integralInfo &&
          this.integralInfo.integralInfo &&
          this.integralInfo.integralInfo.integralUnitName) ||
        ""
      );
    },

    // 积分名称
    integralName() {
      if (
        this.integralInfo &&
        this.integralInfo.integralInfo &&
        this.integralInfo.integralInfo.integralName
      ) {
        return this.integralInfo.integralInfo.integralName;
      }
      return this.TLang('积分', 'orderConfirm');
    },
    // 抵扣金额
    deductionMoney() {
      if (
        this.integralInfo &&
        this.integralInfo.integralInfo &&
        this.integralInfo.integralInfo.deductionMoney
      ) {
        return Number(
          (this.integralInfo.integralInfo.deductionMoney * window.union_scale) /
            100
        ).toFixed(2);
      }
      return "";
    },
    // 不可用积分
    unavailableIntegralList() {
      if (
        this.integralInfo &&
        this.integralInfo.integralInfo &&
        this.integralInfo.integralInfo.unavailableIntegralList &&
        this.integralInfo.integralInfo.unavailableIntegralList.length
      ) {
        return this.integralInfo.integralInfo.unavailableIntegralList;
      }
      return [];
    },
    // 可用积分
    usableIntegralInfoList() {
      if (
        this.integralInfo &&
        this.integralInfo.integralInfo &&
        this.integralInfo.integralInfo.usableIntegralInfoList &&
        this.integralInfo.integralInfo.usableIntegralInfoList.length
      ) {
        console.log("看看改变吧",this.integralInfo.integralInfo.usableIntegralInfoList);
        return this.integralInfo.integralInfo.usableIntegralInfoList;
      }
      return [];
    },
  },
  watch: {
    interestsInfo: {
      handler(val) {
        this.integralInfo = JSON.parse(JSON.stringify(val));
        // this.handleData();
      },
      deep: true,
    },
  },
  created() {},
  methods: {
    // 改变点击状态
    changeStatus(index, item) {
      // 苏交科积分盘点中，不可点击
      if (this.integralInfo && this.integralInfo.isThirdAccountInventory === 1) {
        Toast.info(this.integralInfo.thirdAccountInventoryPrompt || '积分盘点中，请稍后再试',1.5);
        return;
      }
      var allCard = this.$parent.allSelectCard;
      if (this.usableIntegralInfoList[index].checked === "Y") {
        this.usableIntegralInfoList[index].checked = "N";

        let count = allCard.enterprisePoints.findIndex(
          (obj) => obj.cardNo === item.pointId
        );
        if (count > -1) {
          allCard.enterprisePoints.splice(count, 1);
        }
      } else {
        if (!this.$parent.enableSelect) {
          Toast.info(payTotastNames.noRemainPay, 1.5);
          return;
        }
        let obj = {};
        obj.cardNo = item.pointId;
        obj.value = item.checkedValue;
        this.usableIntegralInfoList[index].checked = "Y";
        let count = allCard.enterprisePoints.findIndex(
          (per) => per.cardNo === item.pointId
        );
        if (count > -1) {
          allCard.enterprisePoints.splice(count, 1, obj);
        } else {
          allCard.enterprisePoints.push(obj);
        }
      }
      allCard.chooseType = 4;
      this.sendGio('账户积分', '选择可用积分', {
        contentTitle: item.pointName,
      });
      this.$emit('func', allCard);
    },
    changeShow() {
      this.showStatus = !this.showStatus;
    },
    formatBalance(balance) {
      if (!balance) {
        return ["0", "00"];
      }
      const newBalance = Number((balance * window.union_scale) / 100).toFixed(
        2
      );
      return newBalance.split(".");
    },
  },
};
</script>
<style lang="less" scoped>
.transition {
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
}

.rotate(@rotateDegree) {
  color: #111;
  font-size: 22px;
  font-weight: 700;
  -webkit-transform: rotateZ(@rotateDegree);
  transform: rotateZ(@rotateDegree);
  cursor: pointer;
  .transition;
}

.rotate-180 {
  .rotate(180deg);
}
.is-reverse {
  -webkit-transform: rotateZ(0);
  transform: rotateZ(0);
}
.balance-content {
  padding: 24px 0 0 24px;
}
.top {
  font-size: 20px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #111111;
  margin-bottom: 14px;
  .tip {
    margin-left: 32px;
    color: #333;
    font-size: 14px;
    font-weight: 400;
    .red {
      color: #f44545;
    }
  }
}
.use-select {
  width: 260px;
  height: 25px;
  margin-left: 24px;
  margin-bottom: 12px;
  .use-tab {
    position: relative;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #333333;
    cursor: pointer;
  }
  .un-use-tab {
    margin-left: 30px;
  }
  .active {
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #3d96e2;
  }
  .active:after {
    content: "";
    width: 35px;
    height: 2px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -4px;
    background: linear-gradient(202deg, #5cb4ec 0%, #3d96e2 100%);
    border-radius: 3px;
  }
}

.sel-border {
  border: 2px solid #3d96e2;
}
.noSel-border {
  border: 1px solid #e5e5e5;
}
.empty-data {
  width: 100%;
  height: 60px;
  text-align: center;
  padding-top: 30px;
  font-size: 14px;
  color: #333;
}
ul {
  display: flex;
  flex-wrap: wrap;
  .balance-item {
    box-sizing: border-box;
    width: 270px !important;
    margin-bottom: 24px;
    margin-right: 24px;
    padding-left: 12px;
    padding-top: 12px;
    // border: 1px solid #e5e5e5;
    position: relative;
    .sel-image {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 0;
      right: 0;
    }
    .jifen {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #111111;
      margin-top: -4px;
      margin-bottom: 8px;
    }
    .name {
      font-size: 12px;
      font-weight: 400;
    }
    .interBalance {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3d96e2;
      em {
        font-size: 12px;
      }
    }
    .due {
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #666666;
      margin-top: 12px;
    }
  }
  .use-bg {
    background: #f8fcff;
    padding-bottom: 12px;
  }
  .nouse-bg {
    background: #f6f6f7;
    padding-bottom: 12px;
  }
  .nouse-color {
    color: #333;
  }
  .use-color {
    color: #3d96e2;
  }
  .gray-color {
    color: #666;
  }
  .reason-tip {
    margin-top: 10px;
    border-top: 1px solid #e5e5e5;
    font-size: 12px;
    color: #f44545;
    margin-left: -12px;
    padding-left: 12px;
    img {
      width: 12px;
      height: 12px;
      margin-right: 4px;
    }
  }
  .balance-item:nth-child(4n) {
    margin-right: 0;
  }
}
</style>
